import { reduxForm } from 'redux-form/immutable'
import { connect } from 'react-redux'
import i18next from 'i18next'

import LoginForm from '../LoginForm'
import { postAuthEmail } from 'store/entities/identity/actions'
import { clearLoginError } from 'store/entities/ui/actions'
import { getUILoginEmailError, getUILoginSubmitting } from 'store/entities/ui/selectors'

const mapStateToProps = state => ({
  loginError: getUILoginEmailError(state),
  isSubmitting: getUILoginSubmitting(state),
})

const validate = values => {
  const errors = {}
  const email = values.get('email')
  if (email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
    errors.email = i18next.t('login:Please enter a valid email')
  }
  return errors
}

const formProps = {
  form: 'LOGIN_EMAIL_FORM',
  onSubmit: (values, dispatch) => {
    const email = values.get('email')
    if (email) {
      dispatch(postAuthEmail(email.trim()))
    }
  },
  onChange: (values, dispatch, props) => {
    if (props.loginError) {
      dispatch(clearLoginError())
    }
  },
  touchOnBlur: false,
  validate,
}

export default connect(mapStateToProps)(reduxForm(formProps)(LoginForm))
